export const AVATARS = 'avatars';
export const BLOGS = 'blogs';
